import React from "react";
import { faInstagram } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";

const assetBase = "/assets/images/marketing";

const footerLinks = [
  { label: "Home", to: "/" },
  { label: "Getting Started", to: "/getting-started" },
  { label: "Pricing & Sign Up", to: "/pricing" },
  { label: "Contact Us", to: "/contact" },
  { label: "Login", to: "/auth/login" },
];

const MarketingFooter = () => {
  return (
    <footer className="marketing__footer">
      <div className="marketing__container marketing__footer-content">
        <div className="marketing__footer-top">
          <div className="marketing__footer-brand">
            <img
              src={`${assetBase}/insite-logo.png`}
              alt="Insite Work"
              className="marketing__brand-logo marketing__brand-logo--invert"
            />
            <p>
              Simple site &amp; safety system built for Aussie tradies. Manage
              assets, sites, work and safety through one easy-to-use platform.
            </p>
          </div>

          <div className="marketing__footer-column">
            <h4>Quick Links</h4>
            <ul className="marketing__footer-links">
              {footerLinks.map((link) => (
                <li key={link.label}>
                  <Link to={link.to}>{link.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="marketing__footer-column">
            <h4>Get in Touch</h4>
            <p className="marketing__footer-copy">
              Free and fast onboarding over the phone.
            </p>
            <a
              href="mailto:hello@insite.work"
              className="marketing__footer-highlight"
            >
              hello@insite.work
            </a>
          </div>
        </div>

        <div className="marketing__footer-bottom">
          <div className="marketing__footer-bottom-row">
            <p>
              <span className="marketing__footer-bottom-copy">
                © {new Date().getFullYear()} Insite.Work. All rights reserved.
              </span>
              <span className="marketing__footer-bottom-links">
                <Link to="/privacy-policy">Privacy Policy</Link> |{" "}
                <Link to="/terms">Terms of Service</Link>
              </span>
            </p>
            <a
              href="https://www.instagram.com/insite_work"
              className="marketing__footer-social"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Follow insite.work on Instagram"
            >
              <FontAwesomeIcon icon={faInstagram} />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default MarketingFooter;
